export const LinkBracket: React.FC<React.HTMLAttributes<SVGSVGElement>> = (
  props
) => (
  <svg
    width='9'
    height='12'
    viewBox='0 0 9 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.51557 6.6373L3.24967 11.7357C2.88571 12.0881 2.29717 12.0881 1.93707 11.7357L1.062 10.8847C0.698037 10.5323 0.698037 9.96251 1.062 9.61387L4.79459 6L1.05813 2.38988C0.694165 2.03749 0.694165 1.46767 1.05813 1.11903L1.9332 0.264292C2.29717 -0.0880975 2.88571 -0.0880975 3.2458 0.264292L8.5117 5.3627C8.87566 5.71134 8.87566 6.28491 8.51557 6.6373Z'
      fill='currentColor'
    />
  </svg>
);
